var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.10345 7.53448C9.10345 9.8198 7.25083 11.6724 4.96552 11.6724C2.6802 11.6724 0.827585 9.8198 0.827585 7.53448C0.827585 5.24917 2.6802 3.39655 4.96552 3.39655H7.52363L6.04043 4.88017L6.62069 5.46552L9.10345 2.98276L6.62069 0.5L6.04043 1.0851L7.52487 2.56897H4.96552C2.22314 2.56897 0 4.7921 0 7.53448C0 10.2769 2.22314 12.5 4.96552 12.5C7.7079 12.5 9.93104 10.2769 9.93104 7.53448H9.10345Z",
    fill: "#203662"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshNew);
export default __webpack_public_path__ + "static/media/refreshNew.7d0a06da947fbe63d3571c18092db242.svg";
export { ForwardRef as ReactComponent };